const uncapitalize = str => str.charAt(0).toLowerCase() + str.slice(1);

export default uncapitalize;
